import { getIdToken } from '../../../configuration/tokenHandling/tokenSlice';
import { store } from '../../../configuration/setup/store';
import { config } from '../../../config';

export const isAuthorised = (allowedRoles: string[]): boolean => {
    if (config.login.mockAuthorization) {
        return true;
    }
    const userRoles: string[] = (getIdToken(store.getState()) as any)?.['roles'] ?? [];
    return !!userRoles && userRoles.some(r => allowedRoles.includes(r));
};